import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "splash.tag_line": "Leadership measured as data",
      // general info
      "general.no_results_found": "No results found",
      "general.copied_to_clipboard": "Copied to clipboard",
      "general.participants_added": "Participants added successfully",
      "general.survey_saved_as_draft": "Survey saved as draft",
      "general.survey_launched": "Survey launched successfully",
      "general.manager_added_successfully": "Manager added successfully",
      "general.employee_added_successfully": "Employee added successfully",
      "general.manager_not_added": "Manager not added",
      "general.employee_not_added": "Employee not added",
      "general.reminder_sent": "Reminder sent",

      // error messages
      "error.errors_to_correct": "Errors to correct:",
      "error.field_length_2_chars": "Field must be at least 2 characters long",
      "error.invalid_email": "Invalid email address",

      //field options / names
      "field.options_choose": "Choose one of the following",
      "field.options_full_list": "I have a full list of employees and managers",
      "field.options.partial_list":
        "I have no list or partial list of managers",
      "field.have_list_managers": "Do you have a list of managers?",
      "field.yes": "Yes",
      "field.no": "No",
      "field.will_managers_add_employees": "Will managers add employees?",
      "field.first_name": "First Name",
      "field.last_name": "Last Name",
      "field.email": "Email",
      "field.manager_emails": "Manager Emails",
      "field.manager": "Manager",
      "field.group": "Group",
      "field.language": "Language",

      // Survey header menu
      "menu.logout": "Logout",
      "menu.new_survey": "New Survey",

      "menu.analyze.company": "Company",
      "menu.analyze.groups": "Groups",
      "menu.analyze.managers": "Managers",

      "menu.manage.managers": "Managers",
      "menu.manage.surveys": "Surveys",
      "menu.manage.groups": "Groups",
      "menu.manage.employees": "Employees",
      "menu.manage.uploads": "Uploads",
      "menu.manage.settings": "Settings",

      // Footer texts
      "footer.copyright": "2026 VeeMind",
      "footer.trust": "",
      "footer.support": "Support",
      "footer.impressum": "Impressum",

      //Survey Steps
      "surveySteps.completed_message": "you have already completed this survey",

      // Survey step 1
      "step1.owner": "You are providing feedback for",
      "step1.owner_suffix": "",
      "step1.feature1": "Purpose",
      "step1.feature2": "Feedback",
      "step1.feature3": "Data",
      "step1.feature4": "Goal",
      "step1.explainer1":
        "You have been invited to participate in this survey to share your feedback on leadership behavior.",
      "step1.explainer2":
        "Please be honest and supportive in your answers and comments.",
      "step1.explainer3":
        "Your responses will be kept confidential and anonymous.",
      "step1.explainer4":
        "Your input will help the manager reflect on their leadership approach and strengthen collaboration.",
      "step1.cta": "Start survey",
      "step1.timeestimate":
        "Completing the survey should take about 10-15 minutes.",
      "step1.minutes": "",

      // Survey step 2
      "step2.title": "Leadership Survey",
      "step2.description": "You are leaving feedback for",
      "step2.cta": "NEXT STEP",

      //Survey Step 2 Values
      completely_agree: "Completely agree",
      mostly_agree: "Mostly agree",
      somewhat_agree: "Somewhat agree",
      somewhat_disagree: "Somewhat disagree",
      mostly_disagree: "Mostly disagree",
      completely_disagree: "Completely disagree",
      not_applicable: "I cannot assess",

      // Survey step 3
      "step3.title": "You're almost there!",
      "step3.description":
        "You're close to finishing the survey. In this final section, you can provide additional feedback to your manager.",
      "step3.description-self": "Your almost done with the self-assessment",
      "step3.cta": "Submit survey",

      // Survey step 4
      "step4.title": "Thank you, we appreciate\n your input!",
      "step4.text":
        "If you want to share your experience with VeeMind,\n we would be happy to hear about it at support@veemind.com",
      "step4.teasertitle": "Are you a good leader?",
      "step4.teasertext":
        "Do you want to receive good and honest feedback from your employees? Start your own survey at for free with VeeMind",
      "step4.cta": "START SURVEY",

      // Content Card (Academy)
      "academy.category.title": "Element",
      "academy.subcategory.title": "Skill",
      "academy.reading_time": "Reading time",
      "academy.minutes": "min",
      "academy.intro.title": "Intro",
      "academy.content.title": "What can I do?",
      "academy.read-more": "READ MORE",

      //Home
      "home.card_small_title": "Survey",
      "home.cta": "Select survey",

      //Login
      "login.title": "Learn about your own leadership style",
      "login.text":
        "Create a survey to ask your team, or yourself,\n what kind of leader you are",
      "login.cta": "LOGIN",
      "login.terms_of_use.text": "By creating an account, I agree\nto the",
      "login.terms_of_use.cta": "terms of Services",

      //Survey Conf
      "surveyConf.category.title": "Element",
      "surveyConf.subcategory.title": "Skill",
      "surveyConf.subcategory.question_title": "Question",
      "surveyConf.page_title": "Start your survey",
      "surveyConf.page_text":
        "This is a preview of the questions that will be distributed",
      "surveyConf.box.title": "GUIDE",
      "surveyConf.box.text_1":
        "In the next step, you will be asked to distribute access information to your team members, you can do this by providing their e-mails or giving them a direct link\n\nThe sections below illustrate the system we will use to assess your leadership style and the question that we ask your team",
      "surveyConf.box.text_2":
        "To see the questions we will send to your team members, click to explore each element below. We will also ask them to answer three open questions where they can share their suggestions and feedback.",
      "surveyConf.stats.time": "This survey will approx. take:",
      "surveyConf.minutes": "min",
      "surveyConf.stats.categories": "Selected elements:",
      "surveyConf.stats.questions": "Total Questions:",
      "surveyConf.stats.cta": "CREATE SURVEY",

      //SurveyResults
      "surveyResults.info.click_to_complete_self_survey":
        "Click here to complete the self survey (opens in a new window).",
      "surveyResults.info.after_survey_refresh":
        "After completing the survey, please refresh the page to view the results.",
      "surveyResults.info.no_results_for_manager":
        "There are no survey results for this manager",
      "surveyResults.info.self_assessment_required":
        "You are required to complete the following self-surveys before you can view the results",
      "surveyResults.summary_results_scorecard": "Results scorecard",
      "surveyResults.summary.leadership_elements":
        "Leadership elements evaluated",
      "surveyResults.summary.participants": "Number of participants",
      "surveyResults.summary.skills": "Leadership skills evaluated",
      "surveyResults.summary.answers_given": "Answers given",
      "surveyResults.summary.total_exercises":
        "Total exercises available in full version",
      "surveyResults.summary.opinions_given":
        "Opinions written by participants",
      "surveyResults.summary.time_average": "Time spent on avg.",
      "surveyResults.summary.completion_rate": "Completion rate",
      "surveyResults.summary.title": "Summary",
      "surveyResults.summary.box_text_1": "VeeMind",
      "surveyResults.summary.box_text_2": "Enterprise",
      "surveyResults.summary.box_cta": "Ask us via e-mail",
      "surveyResults.summary.text_bold":
        "This survey is a teaser for the enterprise version of VeeMind",
      "surveyResults.summary.text_1": "Thank you for taking time to use it",
      "surveyResults.summary.text_2":
        "If you would like to use our solution in your company, our platform enables further data-driven decision-making, such as:",
      "surveyResults.summary.text_list_1":
        "Whole company leadership quality overview",
      "surveyResults.summary.text_list_2": "Historical statistics",
      "surveyResults.summary.text_list_3": "Easy survey management",

      //Page Content
      "surveyResults.page_title": "Results overview",
      "surveyResults.page_text": "This page shows and explains your results",
      "surveyResults.no_results.title": "No results",
      "surveyResults.no_results.text":
        "Results will become available as soon as the surveys are completed",
      "surveyResults.strength.title": "STRENGTH",
      "surveyResults.weakness.title": "WEAKNESS",
      "surveyResults.feedback.title": "Open-ended feedback",
      "surveyResults.feedback.no_results": "No results available",
      "surveyResults.feedback.show_all": "show all",
      "surveyResults.feedback.generate_summary": "Generate Summary",
      "surveyResults.feedback.generating_summary": "Generating Summary...",
      "surveyResults.feedback.summary_generated": "Summary Generated",
      "surveyResults.feedback.summary_error":
        "Error generating summary. Please try again.",
      "surveyResults.feedback.regenerate_summary": "Regenerate Summary",
      "surveyResults.feedback.regenerating_summary": "Regenerating Summary...",
      "surveyResults.category.title": "element",
      "surveyResults.subcategory.title": "Skill",
      "surveyResults.category.subcategories_included": "skills included",
      "surveyResults.subcategory.tooltip.self-assess": "Self assess",
      "surveyResults.subcategory.academy-cta": "Improve",
      "surveyResults.subcategory.question_title": "Question",
      "surveyResults.select_survey": "Select one or more surveys",
      "surveyResults.all_surveys": "All surveys",

      //Tabs
      //Total Results
      "tab.results.survey_title.label": "Survey title",
      "tab.results.started_on.label": "Started on",
      "tab.results.end_date.label": "End date",
      "tab.results.end_date.text": "or when all responses are submitted",
      "tab.results.status.label": "Status",
      "tab.results.survey_closed": "This survey is now closed",

      //Tab Email
      "tab.email.title": "Using e-mail",
      "tab.email.invite-emails.label": "Invite via e-mail",
      "tab.email.invite-emails.placeholder":
        "Recipient e-mails (comma separated)",
      "tab.email.invite-emails.not_valid_message":
        "The following emails are not valid",
      "tab.email.invite-emails.already_sent_message":
        "The following have already been invited",
      "tab.email.invite-emails.send_to_your_email_message":
        "You cannot send an invite to yourself",
      "tab.email.tracking.label": "Response tracking",
      "tab.email.tracking.list_item_1": "automated reminders",
      "tab.email.tracking.list_item_2": "progress tracking",
      "tab.email.tracking.list_item_3": "survey closes with last respondent",
      "tab.email.end_date.label": "End date",
      "tab.email.end_date.text": "or when all responses are submitted",
      "tab.email.self-assess.cta": "self-assess",
      "tab.email.invite.cta": "invite",

      //Tab URL
      "tab.url.title": "Using a link",
      "tab.stats.title": "Status",
      "tab.url.invite-url.label": "Share URL",
      "tab.url.invite-url.text":
        "Use the link above to share with your team and make sure to click the button to start the survey.",
      "tab.url.invite-url.cta.share": "share",
      "tab.url.invite-url.cta.copied": "copied!",
      "tab.url.tracking.label": "Response tracking",
      "tab.url.tracking.text":
        "Inviting with e-mails helps you get the best results. E-mail invites enable:",
      "tab.url.tracking.list_item_1": "automated reminders",
      "tab.url.tracking.list_item_2": "progress tracking",
      "tab.url.tracking.list_item_3": "survey closes with last respondent",
      "tab.url.end_date.label": "End date",
      "tab.url.end_date.text": "Will close on midnight",
      "tab.url.self-assess.cta": "self-assess",

      //Register Modal
      "modal.register_user.title": "Tell us more about yourself",
      "modal.register_user.text":
        "We're still learning how to make this platform relevant across industries and contexts - the data you provide will be tremendously valuable. Sorry for the inconvenience & thank you!",
      "modal.register_user.q1": "What is your name and surname?",
      "modal.register_user.first_name": "First name",
      "modal.register_user.last_name": "Last name",
      "modal.register_user.q2": "What best describes your role?",
      "modal.register_user.choose": "Choose one",
      "modal.register_user.q3": "What is your industry?",
      "modal.register_user.q4": "Specify your industry",
      "modal.register_user.q5": "Where are you located?",
      "modal.register_user.q6": "What is the size of the team you manage?",
      "modal.register_user.q7": "What is the size of your company?",
      "modal.register_user.q8":
        "Does your company have a leadership and/or company culture guide?",
      "modal.register_user.cta": "Save",

      //Managers
      "managers.search_input": "Search managers",
      "managers.add_new_btn": "Add",
      "managers.no_managers_found": "No managers found.",
      "managers.copy_invite": "Copy link to survey",

      //Table
      "table.edit_btn": "Edit",
      "table.save_btn": "Save",
      "table.archive_btn": "Archive",
      "table.delete_btn": "Delete",

      //Modal New Manager
      "modal.new_manager.title": "New Manager",
      "modal.new_manager.first_name": "First Name",
      "modal.new_manager.last_name": "Last Name",
      "modal.new_manager.email": "Email",
      "modal.new_manager.submit_btn": "Add",

      //Modal Link Employee
      "modal.link_employee.title": "Select Employees to Link",
      "modal.link_employee.search_input": "Search by name",
      "modal.link_employee.selection": "Employee Selection",
      "modal.link_employee.selected_employees": "Selected Employees",
      "modal.link_employee.link_button": "Link Employee",
      "modal.link_employee.cancel_button": "Cancel",

      //Surveys
      "surveys.start": "Start",
      "surveys.end": "End",
      "surveys.invite_link": "Invite link",
      "surveys.send_reminder": "Send reminder",
      "surveys.not_active": "Survey Not Active",
      "surveys.completed": "Survey Completed",
      "surveys.copy": "Copy link",
      "surveys.all_surveys_placeholder": "All Surveys",
      "surveys.draft_surveys_placeholder": "Draft Surveys",
      "surveys.active_surveys_placeholder": "Active Surveys",
      "surveys.invited_managers": "Invited Managers",
      "surveys.invited_employees": "Invited Employees",
      "surveys.title": "Surveys",
      "surveys.add_new_btn": "Add",
      "surveys.starting_date": "Survey Starting Date",
      "surveys.closing_date": "Survey Closing Date",
      "surveys.completion_rate": "Completion Rate",
      "surveys.closed": "Survey Closed",
      "surveys.closed_yes": "Yes",
      "surveys.closed_no": "No",
      "surveys.invite_based": "Survey Invite Based",
      "surveys.link": "Survey Link",
      "surveys.link_to_survey": "Link to Public Survey",
      "surveys.invite_based_no": "No",
      "surveys.invite_based_yes": "Yes",
      "surveys.no_results_found": "No survey results found.",
      "surveys.survey_not_started": "Survey has not started yet",
      "surveys.status.not_started": "Not Started",
      "surveys.status.active": "Active",
      "surveys.status.closed": "Closed",
      "surveys.status.completed": "Completed",
      "surveys.status.in_progress": "In progress",
      "surveys.button.see_results": "See Results",
      "surveys.button.add_participants": "Add Participants",
      "surveys.button.duplicate": "Duplicate",
      "surveys.tab.managers": "Managers",
      "surveys.tab.employees": "Employees",
      "surveys.table_head.name_email": "Name / Email",
      "surveys.table_head.email": "Email",
      "surveys.table_head.manager": "Manager",
      "surveys.table_head.total_responses": "Total responses",
      "surveys.table_head.team_members_invited": "Team members invited",
      "surveys.table_head.status": "Status",
      "surveys.table_head.total_invites_received": "Total invites received",
      "surveys.manager_self_survey_link": "Manager self-survey link",
      "surveys.view_as_manager": "View as manager",
      "surveys.results_preview": "Results preview",
      "surveyResults.view_as_banner":
        "Viewing results as {{name}} (admin preview)",
      "surveyResults.view_as_exit": "Exit preview",
      "surveys.name_filter_placeholder": "Search",

      //Create Survey
      "create_survey.create_draft": "Create draft",
      "create_survey.save_draft": "Save draft",
      "create_survey.clear_selection": "Clear selection",
      "create_survey.select_all_managers_and_employees":
        "Select all managers and employees",
      "create_survey.select_all_managers": "Select all managers",
      "create_survey.link_existing_employee": "Link existing employee",
      "create_survey.cancel_btn": "Cancel",
      "create_survey.launch_btn": "Launch",
      "create_survey.template_label": "Template",
      "create_survey.start_date_label": "Start date",
      "create_survey.duration_label": "Duration",
      "create_survey.managers_invite_employees_label":
        "Managers Invite their Employees",
      "create_survey.survey_title_lable": "Survey Title",
      "create_survey.invite_based_survey_label":
        "Send employees invites via e-mail",
      "create_survey.self_survey_requested_label": "Self-assessment requested",
      "create_survey.add_manager_btn": "Add manager",
      "create_survey.select_manager_title": "Select manager",
      "create_survey.add_employee_btn": "Add employee",
      "create_survey.select_employee_title": "Select employees",
      "create_survey.launch_btn_loading": "Loading...",

      //Groups
      "tags.search_input": "Search groups",
      "tags.add_new_btn": "Add",

      //Modal New Group
      "modal.new_group.title": "New group",
      "modal.new_group.name_label": "Name",
      "modal.new_group.manager_label": "Manager",
      "modal.new_group.submit_btn": "Add",

      //Employees
      "employees.search_input": "Search employees",
      "employees.add_new_btn": "Add",

      //Modal New Employee
      "modal.new_employee.title": "New employee",
      "modal.new_employee.first_name_label": "First name",
      "modal.new_employee.last_name_label": "Last name",
      "modal.new_employee.email_label": "Email",
      "modal.new_employee.manager_label": "Manager",
      "modal.new_employee.submit_btn": "Add",

      //Uploads
      "uploads.select_label": "Select manager or employee",
      "uploads.select_placeholder": "Select import type",
      "uploads.manager_option": "Manager",
      "uploads.employee_option": "Employee",
      "uploads.step_1.title": "Select manager or employee",
      "uploads.step_1.text": "",
      "uploads.step_1.title_manager": "Manager",
      "uploads.step_1.text_manager": "",
      "uploads.step_1.title_employee": "Employee",
      "uploads.step_1.text_employee": "",
      "uploads.step_1.manager_btn": "Select",
      "uploads.step_1.employee_btn": "Select",

      //Upload Form
      "upload_form.import_successful": "Import successful",
      "upload_form.import_update_successful": "Update successful",
      "upload_form.managers_title": "Upload managers",
      "upload_form.employees_title": "Upload employees",
      "upload_form.sample_file_label": "Sample file",
      "upload_form.sample_file_btn": "Download sample file",
      "upload_form.upload_file_label": "Upload file",
      "upload_form.table.field_name": "Field name",
      "upload_form.table.available_fields": "Available fields",
      "upload_form.table.edit": "Edit",
      "upload_form.table.select_placeholder": "Choose one of the following",
      "upload_form.table.remove_btn": "Remove",
      "upload_form.table.import_btn": "Import",
      "upload_form.available_fields_label": "Available fields",

      //New Survey
      "new_survey.back_btn": "Back",
      "new_survey.next_btn": "Next",
      "new_survey.done_btn": "Done",
      "new_survey.step_1.title": "Launch a survey",
      "new_survey.step_1.text":
        "Would you like to create a new survey from scratch, for new managers and employees or for managers and employees who have been previously uploaded?",
      "new_survey.step_1.title_yes":
        "I want to upload new managers and employees",
      "new_survey.step_1.text_yes":
        "In the next step, you will be able to download an Excel template for inputting managers and employees",
      "new_survey.step_1.title_no":
        "I want to upload managers or add them by hand",
      "new_survey.step_1.text_no":
        "You will have a choice of delegating this task to your managers, or you can do it manually",
      "new_survey.step_1.title_custom":
        "I want to launch a survey for existing managers",
      "new_survey.step_1.text_custom": "",
      "new_survey.step_1.cta_custom": "Create new survey",
      "new_survey.step_2.title": "Mapping managers to reports",
      "new_survey.step_2.manager_handles_invite_text":
        "Do you want to ask your managers to add their employees? You will be able to inspect who they have invited",
      "new_survey.step_2.managers_list_text":
        "Do you have a list or managers that you can upload or prepare, or will you be adding them manually?",
      "new_survey.step_5.title": "Ready to launch",
      "new_survey.step_5.text_1": "You are now ready to launch the survey",
      "new_survey.step_5.text_2": "In the next step",
      "new_survey.step_5.text_2.li_1":
        "Duplicates are ignored, people are recognized by their e-mail",
      "new_survey.step_5.text_2.li_2":
        "You will be able to preview the import in the next step",
      "new_survey.step_5.text_3": "While the survey is active",
      "new_survey.step_5.text_3.li_1":
        "You will have the option to inspect and edit invitees managers throughout the duration of the survey",

      //Analyze Company
      "analyze.company.all_surveys_placeholder": "All surveys",
      "analyze.company.all_groups_placeholder": "All groups",
      "analyze.company.date_placeholder": "All time",
      "analyze.company.name_filter_placeholder": "Filter by name",
      "analyze.company.export_btn": "Export",
      "analyze.company.primary_box":
        "How many managers have increased their overall score?",
      "analyze.company.data_points_title": "Key data points",
      "analyze.company.feedback_title": "Qualitative feedback",
      "analyze.company.feedback_box_title": "Feedback",
      "analyze.company.graph_title": "Company matrix",
      "analyze.company.graph_text":
        "By clicking on each competency on the left, you will see the descriptions and corresponding questions used to assess the leadership competency. By clicking on the points in the graph, you can see the scores achieved.",
      "analyze.company.insights_title": "Category description",
      "analyze.company.questions_title": "Sample questions",
      "analyze.company.cat_description_title": "Category description",

      //Analyze Managers
      "analyze.managers.all_surveys_placeholder": "All surveys",
      "analyze.managers.all_groups_placeholder": "All groups",
      "analyze.managers.date_placeholder": "All time",
      "analyze.managers.name_filter_placeholder": "Filter by name",
      "analyze.managers.export_btn": "Export",
      "analyze.managers.generate_summaries_btn": "Generate Summaries",
      "analyze.managers.regenerate_confirmation":
        "Are you sure you want to regenerate summaries for all managers? This may take some time.",
      "analyze.managers.generating_summaries": "Generating...",
      "analyze.managers.primary_box":
        "Which element of leadership has changed the most?",
      "analyze.managers.insights_title": "Category description",
      "analyze.managers.questions_title": "Sample questions",
      "analyze.managers.cat_description_title": "Category description",
      "analyze.managers.feedback_box_title": "Feedback",
      "analyze.managers.summary": "Summary",
      "analyze.managers.list": "List",
      "analyze.managers.download_pdf": "Download PDF",
      "analyze.managers.generating_pdf": "Generating PDF...",
      "analyze.managers.popup_blocked":
        "Popup was blocked. Please allow popups for this site and try again.",
      "analyze.managers.no_results": "No results",
      "analyze.managers.summary_generated_success":
        "Manager summary generated successfully",
      "analyze.managers.no_closed_surveys":
        "No closed surveys found yet for this manager. Surveys must be closed before summaries can be generated.",
      "analyze.managers.no_open_text_feedback":
        "This manager's closed surveys have no written feedback to summarize.",
      "analyze.managers.no_closed_surveys_company":
        "Found {{count}} survey(s) for managers in this company, but none have been closed yet. Surveys must be closed before summaries can be generated.",
      "analyze.managers.no_closed_surveys_feedback":
        "No closed surveys with user feedback found for managers in this company",
      "analyze.managers.summaries_generated_success":
        "Manager summaries generated successfully for {{count}} manager(s)",
      "analyze.managers.summaries_generation_started":
        "Generating summaries for {{count}} manager(s) in the background. You can keep working; we'll let you know when they're ready.",
      "analyze.managers.summaries_already_generating":
        "Summaries are already being generated for this company. We'll let you know when they're ready.",
      "analyze.managers.summaries_progress":
        "Generating summaries: {{processed}} of {{total}} managers done",
      "analyze.managers.summaries_ready":
        "Summaries ready for {{count}} of {{total}} manager(s)",
      "analyze.managers.summaries_interrupted":
        "Summary generation was interrupted. Please click \"Generate Summaries\" again.",
      "analyze.managers.summary_header": "Summary of Feedback",
      "analyze.managers.recommendation_header": "Top Recommendation:",
      "analyze.managers.count_statement":
        "Overall, the evaluation is based on {{count}} usable responses.",
      "anaylze.managers.self_assessed": "self-assessed",

      //Analyze Survey
      "analyze.survey.back_btn": "Back",

      //Analyze Groups
      "analyze.groups.rank": "Rank",
      "analyze.groups.highest_ratings": "Highest ratings",
      "analyze.groups.highest_ratings_subtitle": "95th percentile",
      "analyze.groups.distribution": "Distribution",
      "analyze.groups.list": "List",
      "analyze.groups.managers": "managers",
      "analyze.groups.inspect": "Inspect",
      "analyze.groups.rest": "Rest",
      "analyze.groups.lowest_ratings": "Lowest ratings",
      "analyze.groups.lowest_ratings_subtitle": "5th percentile",

      "analyze.widgets.leadership_increase_most_by_percent": "has increased",
      "analyze.widgets.leadership_decrease_most_by_percent": "has decreased",
      "analyze.widgets.leadership_change_most_least_score.most":
        "has the most change",
      "analyze.widgets.leadership_change_most_least_score.least":
        "has the least change",
      "analyze.widgets.leadership_highest_score": "has the highest score",
      "analyze.widgets.leadership_lowest_score": "has the lowest score",
      "analyze.widgets.question_lowest_score_all_manager":
        "Question with the lowest score among all managers",
      //Settings Page
      "settings.title": "Company Settings",
      "settings.data.title": "Company Data",
      "settings.data.name": "Name:",
      "settings.data.address": "Address:",
      "settings.data.address_number": "Address Number:",
      "settings.data.btn": "Save Company Data",
      "settings.data.save_language": "Save Language",
      "settings.save_other_settings": "Save Other Settings",
      "settings.self_survey_required": "Self-assessment required",
      "settings.aiPrompt.title": "AI Summary Prompt Template",
      "settings.aiPrompt.description":
        "Customize the AI prompt template for generating manager summaries. This template will be used when generating AI summaries for survey results.",
      "settings.aiPrompt.loadGlobal": "Load Global Template",
      "settings.aiPrompt.resetToGlobal": "Use Global Template",
      "settings.aiPrompt.companySpecific":
        "You are editing a company-specific template",
      "settings.aiPrompt.usingGlobal": "You are using the global template",
      "settings.aiPrompt.saveAsCompany": "Save as Company Template",
      "settings.aiPrompt.updateCompany": "Update Company Template",
      "settings.aiPrompt.availableVariables": "Available Variables:",
      "settings.aiPrompt.variables.quantitativeData":
        "{{quantitativeData}} - Quantitative survey scores and metrics",
      "settings.aiPrompt.variables.qualitativeData":
        "{{qualitativeData}} - Qualitative feedback and comments",
      "settings.aiPrompt.role": "Role",
      "settings.aiPrompt.rolePlaceholder":
        "Enter the role/character description (the <Rolle> section)...",
      "settings.aiPrompt.template": "Template",
      "settings.aiPrompt.templatePlaceholder":
        "Enter the main prompt template (everything else)...",
      "settings.aiPrompt.save": "Save Prompt",
      "settings.aiPrompt.saving": "Saving...",
      "settings.aiPrompt.saved": "Template saved successfully!",
      "settings.aiPrompt.error": "Error saving template. Please try again.",
      "settings.language_options": "Language Options",
      "settings.academy_contents": "Academy Contents",
      "settings.other_settings": "Other Settings",
      "settings.default_language": "Default Language",
      "settings.available_languages": "Available Languages",
      "settings.custom_fields.title": "Custom Field",
      "settings.new_field.title": "Add New Custom Field",
      "settings.choose_widget": "Choose Widget",
      "settings.save_widgets": "Save Widget Choices",
      "settings.new_field.name": "Field Name",
      "settings.new_field.btn": "Add Custom Field",
      "settings.selected": "Selected",
      "settings.not_selected": "Not Selected",
      "settings.data.saved": "Company data saved",
      "settings.enabled": "Enabled",
      "settings.disabled": "Disabled",

      //modal Upload
      "modal.btn.save": "Save",
    },
  },
  de: {
    translation: {
      "splash.tag_line": "Führung als Daten gemessen",
      // general info
      "general.no_results_found": "Keine Ergebnisse gefunden",
      "general.copied_to_clipboard": "In die Zwischenablage kopiert",
      "general.participants_added": "Teilnehmer erfolgreich hinzugefügt",
      "general.survey_saved_as_draft": "Umfrage als Entwurf gespeichert",
      "general.survey_launched": "Umfrage erfolgreich gestartet",
      "general.manager_added_successfully": "Manager erfolgreich hinzugefügt",
      "general.employee_added_successfully":
        "Mitarbeiter erfolgreich hinzugefügt",
      "general.manager_not_added": "Manager nicht hinzugefügt",
      "general.employee_not_added": "Mitarbeiter nicht hinzugefügt",
      "general.reminder_sent": "Erinnerung gesendet",

      // error messages
      "error.errors_to_correct": "Fehler zu korrigieren:",
      "error.field_length_2_chars": "Feld muss mindestens 2 Zeichen lang sein",
      "error.invalid_email": "Ungültige E-Mail-Adresse",

      //field options / names
      "field.options_choose": "Wählen Sie eine der folgenden Optionen",
      "field.options_full_list":
        "Ich habe eine Liste von Mitarbeitern und Managern",
      "field.options.partial_list":
        "Ich habe keine Liste oder eine teilweise Liste von Managern",
      "field.have_list_managers": "Haben Sie eine Liste von Managern?",
      "field.yes": "Ja",
      "field.no": "Nein",
      "field.will_managers_add_employees":
        "Werden Manager Mitarbeiter hinzufügen?",
      "field.first_name": "Vorname",
      "field.last_name": "Nachname",
      "field.email": "Email",
      "field.manager_emails": "Manager E-Mails",
      "field.manager": "Manager",
      "field.group": "Gruppe",
      "field.language": "Sprache",
      "menu.logout": "Abmeldung",
      "menu.new_survey": "Neue Umfrage",
      "menu.analyze.company": "Unternehmen",
      "menu.analyze.groups": "Gruppen",
      "menu.analyze.managers": "Manager",
      "menu.manage.managers": "Managers",
      "menu.manage.surveys": "Umfragen",
      "menu.manage.groups": "Gruppen",
      "menu.manage.employees": "Mitarbeiter",
      "menu.manage.uploads": "Uploads",
      "menu.manage.settings": "Einstellungen",
      "footer.copyright": "2026 VeeMind",
      "footer.trust": "",
      "footer.support": "Support",
      "footer.impressum": "Impressum",
      "surveySteps.completed_message":
        "Sie haben diese Umfrage bereits abgeschlossen",
      "step1.owner": "Sie hinterlassen ein Feedback für",
      "step1.owner_suffix": "",
      "step1.feature1": "Zweck",
      "step1.feature2": "Feedback",
      "step1.feature3": "Daten",
      "step1.feature4": "Ziel",
      "step1.explainer1":
        "Sie sind zu dieser Umfrage eingeladen worden, um Feedback zum Führungshandeln zu geben",
      "step1.explainer2":
        "Bitte seien Sie ehrlich und unterstützend in Ihren Antworten und Kommentaren",
      "step1.explainer3": "Ihre Daten werden vertraulich und anonym behandelt",
      "step1.explainer4":
        "Ihr Beitrag wird der Führungskraft helfen, ihr Führungsverhalten zu reflektieren und die Zusammenarbeit zu stärken.",
      "step1.cta": "Umfrage starten",
      "step1.timeestimate": "Die Bearbeitung sollte ca. 10-15 Minuten dauern.",
      "step1.minutes": "",
      "step2.title": "Umfrage zum Thema Führung",
      "step2.description": "Sie hinterlassen ein Feedback für",
      "step2.cta": "NÄCHSTER SCHRITT",
      completely_agree: "Ich stimme komplett zu",
      mostly_agree: "Ich stimme größtenteils zu",
      somewhat_agree: "Ich stimme eher zu",
      somewhat_disagree: "Ich stimme eher nicht zu",
      mostly_disagree: "Ich stimme größtenteils nicht zu",
      completely_disagree: "Ich stimme gar nicht zu",
      not_applicable: "Kann ich nicht beantworten",
      "step3.title": "Sie haben es fast geschafft!",
      "step3.description":
        "Sie sind fast am Ende der Umfrage. In diesem letzten Teil können Sie Ihrer Führungskraft weiteres Feedback geben.",
      "step3.description-self":
        "Sie sind fast fertig mit der Selbsteinschätzung",
      "step3.cta": "Umfrage abschließen",
      "step4.title": "Vielen Dank, wir schätzen Ihren Beitrag!",
      "step4.text":
        "Wenn Sie Ihre Erfahrungen mit VeeMind teilen möchten, würden wir uns sehr über eine Nachricht an support@veemind.com freuen.",
      "step4.teasertitle": "Sind Sie eine gute Führungskraft?",
      "step4.teasertext":
        "Möchten Sie ehrliches und unterstützendes Feedback von Ihren Mitarbeitern erhalten? Starten Sie Ihre eigene Umfrage kostenlos mit VeeMind",
      "step4.cta": "UMFRAGE STARTEN",
      "academy.category.title": "Kompetenz",
      "academy.subcategory.title": "Fähigkeit",
      "academy.reading_time": "Lesezeit",
      "academy.minutes": "min",
      "academy.intro.title": "Intro",
      "academy.content.title": "Was kann ich tun?",
      "academy.read-more": "MEHR LESEN",
      "home.card_small_title": "Umfrage",
      "home.cta": "Umfrage auswählen",
      "login.title": "Lernen Sie mehr über Ihren eigenen Führungsstil",
      "login.text":
        "Erstellen Sie eine Umfrage, um Ihr Team oder sich selbst zu befragen, welche Art von Führungskraft Sie sind",
      "login.cta": "ANMELDUNG",
      "login.cta_after_error": "Weiter zur Anmeldung",
      "login.terms_of_use.text":
        "Mit der Erstellung eines Kontos, gebe ich meine Zustimmung zu den",
      "login.terms_of_use.cta": "Nutzungsbedingungen",
      "surveyConf.category.title": "Kompetenz",
      "surveyConf.subcategory.title": "Fähigkeit",
      "surveyConf.subcategory.question_title": "Frage",
      "surveyConf.page_title": "Starten Sie Ihre Umfrage",
      "surveyConf.page_text":
        "Hier ist eine Vorschau auf die Fragen, die gestellt werden",
      "surveyConf.box.title": "ANLEITUNG",
      "surveyConf.box.text_1":
        "Im nächsten Schritt werden Sie aufgefordert, die Zugangsinformationen an Ihre Teammitglieder zu verteilen. Sie können dies tun, indem Sie deren E-Mail-Adressen angeben oder ihnen einen direkten Link geben. Die folgenden Abschnitte veranschaulichen das System, das wir zur Beurteilung Ihres Führungsstils verwenden, sowie die Fragen, die wir Ihrem Team stellen",
      "surveyConf.box.text_2":
        "Um die Fragen zu sehen, die wir Ihren Teammitgliedern schicken werden, klicken Sie auf die einzelnen Elemente unten. Wir werden sie auch bitten, drei offene Fragen zu beantworten, in denen sie Ihre Vorschläge und Ihr Feedback mitteilen können.",
      "surveyConf.stats.time": "Die Länge dieser Umfrage beträgt ca.:",
      "surveyConf.minutes": "Min",
      "surveyConf.stats.categories": "Ausgewählte Elemente:",
      "surveyConf.stats.questions": "Fragen insgesamt:",
      "surveyConf.stats.cta": "UMFRAGE ERSTELLEN",
      "surveyResults.info.click_to_complete_self_survey":
        "Klicken Sie hier, um die Selbsteinschätzung abzuschließen (öffnet in einem neuen Fenster).",
      "surveyResults.info.after_survey_refresh":
        "Nach Abschluss der Umfrage aktualisieren Sie bitte die Seite, um die Ergebnisse anzuzeigen.",
      "surveyResults.info.no_results_for_manager":
        "Für diesen Manager liegen keine Umfrageergebnisse vor",
      "surveyResults.info.self_assessment_required":
        "Sie müssen die folgenden Selbsteinschätzungen abschließen, bevor Sie die Ergebnisse anzeigen können",
      "surveyResults.summary_results_scorecard": "Ergebnisübersicht",
      "surveyResults.summary.leadership_elements":
        "Bewertete Führungkompetenzen",
      "surveyResults.summary.participants": "Anzahl der Teilnehmer",
      "surveyResults.summary.skills": "Bewertete Führungsfähigkeiten",
      "surveyResults.summary.answers_given": "Erhaltende Antworten",
      "surveyResults.summary.total_exercises":
        "Alle Übungen in der Vollversion verfügbar",
      "surveyResults.summary.opinions_given": "Erhaltene offene Antworten",
      "surveyResults.summary.time_average": "Durchschnittlich benötigte Zeit",
      "surveyResults.summary.completion_rate": "Finalsierungsquote",
      "surveyResults.summary.title": "Zusammenfassung",
      "surveyResults.summary.box_text_1": "VeeMind",
      "surveyResults.summary.box_text_2": "Unternehmen",
      "surveyResults.summary.box_cta": "Fragen Sie uns per E-Mail",
      "surveyResults.summary.text_bold":
        "Diese Umfrage ist ein Vorgeschmack auf die Unternehmensversion von VeeMind",
      "surveyResults.summary.text_1":
        "Danke, dass Sie sich die Zeit genommen haben, sie zu nutzen",
      "surveyResults.summary.text_2":
        "Wenn Sie unsere Lösung in Ihrem Unternehmen einsetzen möchten, ermöglicht unsere Plattform weitere datengesteuerte Entscheidungen, wie z. B.:",
      "surveyResults.summary.text_list_1":
        "Überblick über die Qualität der gesamten Unternehmensführung",
      "surveyResults.summary.text_list_2": "Historische Statistiken",
      "surveyResults.summary.text_list_3": "Einfache Umfrageverwaltung",
      "surveyResults.page_title": "Ergebnisübersicht",
      "surveyResults.page_text":
        "Diese Seite zeigt und erklärt Ihre Ergebnisse",
      "surveyResults.no_results.title": "Keine Ergebnisse",
      "surveyResults.no_results.text":
        "Die Ergebnisse sind verfügbar, sobald die Umfragen abgeschlossen sind.",
      "surveyResults.strength.title": "STÄRKE",
      "surveyResults.weakness.title": "SCHWÄCHE",
      "surveyResults.feedback.title": "Offenes Feedback",
      "surveyResults.feedback.show_all": "alle anzeigen",
      "surveyResults.feedback.no_results": "Keine Ergebnisse verfügbar",
      "surveyResults.feedback.generate_summary": "Zusammenfassung generieren",
      "surveyResults.feedback.generating_summary":
        "Zusammenfassung wird generiert...",
      "surveyResults.feedback.summary_generated": "Zusammenfassung generiert",
      "surveyResults.feedback.summary_error":
        "Fehler beim Generieren der Zusammenfassung. Bitte versuchen Sie es erneut.",
      "surveyResults.feedback.regenerate_summary":
        "Zusammenfassung neu generieren",
      "surveyResults.feedback.regenerating_summary":
        "Zusammenfassung wird neu generiert...",
      "surveyResults.category.title": "Kompetenz",
      "surveyResults.subcategory.title": "Fähigkeit",
      "surveyResults.category.subcategories_included": "enthaltene Fähigkeiten",
      "surveyResults.subcategory.tooltip.self-assess": "Selbsteinschätzung",
      "surveyResults.subcategory.academy-cta": "Verbessern Sie",
      "surveyResults.subcategory.question_title": "Frage",
      "surveyResults.select_survey": "Wählen Sie eine oder mehrere Umfragen",
      "surveyResults.all_surveys": "Alle Umfragen",
      "tab.results.survey_title.label": "Titel der Umfrage",
      "tab.results.started_on.label": "Angefangen am",
      "tab.results.end_date.label": "Enddatum",
      "tab.results.end_date.text": "oder wenn alle Antworten eingegangen sind",
      "tab.results.status.label": "Status",
      "tab.results.survey_closed": "Diese Umfrage ist nun geschlossen",
      "tab.email.title": "E-Mail verwenden",
      "tab.email.invite-emails.label": "Per E-Mail einladen",
      "tab.email.invite-emails.placeholder":
        "Empfänger E-Mails (durch Komma getrennt)",
      "tab.email.invite-emails.not_valid_message":
        "Die folgenden E-Mails sind nicht gültig",
      "tab.email.invite-emails.already_sent_message":
        "Die folgenden Personen wurden bereits eingeladen",
      "tab.email.invite-emails.send_to_your_email_message":
        "Sie können keine Einladungen an sich selbst senden",
      "tab.email.tracking.label": "Verfolgung der Antwort",
      "tab.email.tracking.list_item_1": "automatische Erinnerung",
      "tab.email.tracking.list_item_2": "Fortschrittsanzeige",
      "tab.email.tracking.list_item_3":
        "Umfrage wird mit dem letzten Befragten abgeschlossen",
      "tab.email.end_date.label": "Enddatum",
      "tab.email.end_date.text": "oder wenn alle Antworten eingegangen sind",
      "tab.email.self-assess.cta": "Selbsteinschätzung",
      "tab.email.invite.cta": "einladen",
      "tab.url.title": "Verwendung eines Links",
      "tab.stats.title": "Status",
      "tab.url.invite-url.label": "URL freigeben",
      "tab.url.invite-url.text":
        "Verwenden Sie den obigen Link, um ihn an Ihr Team weiterzugeben, und klicken Sie auf die Schaltfläche, um die Umfrage zu starten.",
      "tab.url.invite-url.cta.share": "teilen",
      "tab.url.invite-url.cta.copied": "kopiert!",
      "tab.url.tracking.label": "Verfolgung der Antwort",
      "tab.url.tracking.text":
        "Mit Einladungen per E-Mail erzielen Sie die besten Ergebnisse. Einladungen per E-Mail ermöglichen:",
      "tab.url.tracking.list_item_1": "automatische Erinnerungen",
      "tab.url.tracking.list_item_2": "Fortschrittskontrolle",
      "tab.url.tracking.list_item_3":
        "Umfrage wird mit dem letzten Befragten abgeschlossen",
      "tab.url.end_date.label": "End Datum",
      "tab.url.end_date.text": "Wird um Mitternacht geschlossen",
      "tab.url.self-assess.cta": "Selbsteinschätzung",
      "modal.register_user.title": "Nur noch ein Schritt zu Ihrem Ergebnis",
      "modal.register_user.text":
        "Bitte füllen Sie die nachstehenden Felder aus, um Zugang zu Ihrer personalisierten Führungsbewertung zu erhalten",
      "modal.register_user.q1": "Ihr Name?",
      "modal.register_user.first_name": "Vorname",
      "modal.register_user.last_name": "Nachname",
      "modal.register_user.email": "E-Mail",
      "modal.register_user.q2": "Was beschreibt Ihre Rolle am besten?",
      "modal.register_user.choose": "Wählen Sie eine",
      "modal.register_user.q3": "Was ist Ihre Branche?",
      "modal.register_user.q4": "Geben Sie Ihre Branche an",
      "modal.register_user.q5": "Wo befinden Sie sich?",
      "modal.register_user.q6": "Wie groß ist das Team, das Sie leiten?",
      "modal.register_user.q7": "Wie groß ist Ihr Unternehmen?",
      "modal.register_user.q8":
        "Verfügt Ihr Unternehmen über einen Leitfaden für Führung und/oder Unternehmenskultur?",
      "modal.register_user.cta": "Speichern",
      "managers.search_input": "Führungskraft suchen",
      "managers.add_new_btn": "Hinzufügen",
      "managers.no_managers_found": "Keine Führungskraft gefunden.",
      "managers.copy_invite": "Link zur Umfrage kopieren",
      "table.edit_btn": "Bearbeiten",
      "table.save_btn": "Speichern",
      "table.archive_btn": "Archivieren",
      "table.delete_btn": "Löschen",
      "modal.new_manager.title": "Neue Führungskraft",
      "modal.new_manager.first_name": "Vorname",
      "modal.new_manager.last_name": "Nachname",
      "modal.new_manager.email": "E-Mail",
      "modal.new_manager.submit_btn": "Hinzufügen",
      "modal.link_employee.title": "Mitarbeiter zum Verknüpfen auswählen",
      "modal.link_employee.search_input": "Nach Namen suchen",
      "modal.link_employee.selection": "Mitarbeiterauswahl",
      "modal.link_employee.selected_employees": "Ausgewählte Mitarbeiter",
      "modal.link_employee.link_button": "Mitarbeiter verknüpfen",
      "modal.link_employee.cancel_button": "Abbrechen",
      "surveys.start": "Start",
      "surveys.end": "Ende",
      "surveys.invite_link": "Einladungslink",
      "surveys.send_reminder": "Erinnerung senden",
      "surveys.not_active": "Umfrage nicht aktiv",
      "surveys.completed": "Umfrage abgeschlossen",
      "surveys.copy": "Link kopieren",
      "surveys.all_surveys_placeholder": "Alle Umfragen",
      "surveys.draft_surveys_placeholder": "Entwürfe",
      "surveys.active_surveys_placeholder": "Aktive Umfragen",
      "surveys.invited_managers": "Eingeladene Manager",
      "surveys.invited_employees": "Eingeladene Mitarbeiter",
      "surveys.title": "Umfragen",
      "surveys.add_new_btn": "Hinzufügen",
      "surveys.starting_date": "Umfragestartdatum",
      "surveys.closing_date": "Umfrageenddatum",
      "surveys.completion_rate": "Abschlussrate",
      "surveys.closed": "Umfrage geschlossen",
      "surveys.closed_yes": "Ja",
      "surveys.closed_no": "Nein",
      "surveys.invite_based": "Umfrage basierend auf Einladungen",
      "surveys.link": "Umfragelink",
      "surveys.link_to_survey": "Link zur öffentlichen Umfrage",
      "surveys.invite_based_no": "Nein",
      "surveys.invite_based_yes": "Ja",
      "surveys.no_results_found": "Keine Umfrageergebnisse gefunden.",
      "surveys.survey_not_started": "Umfrage hat noch nicht begonnen",
      "surveys.status.not_started": "Nicht gestartet",
      "surveys.status.active": "Aktiv",
      "surveys.status.closed": "Geschlossen",
      "surveys.status.completed": "Abgeschlossen",
      "surveys.status.in_progress": "In Bearbeitung",
      "surveys.button.see_results": "Ergebnisse anzeigen",
      "surveys.button.add_participants": "Teilnehmer hinzufügen",
      "surveys.button.duplicate": "Duplizieren",
      "surveys.tab.managers": "Führungskraft",
      "surveys.tab.employees": "Mitarbeiter",
      "surveys.table_head.name_email": "Name / E-Mail",
      "surveys.table_head.email": "E-Mail",
      "surveys.table_head.manager": "Führungskraft",
      "surveys.table_head.total_responses": "Gesamtantworten",
      "surveys.table_head.team_members_invited": "Eingeladene Teammitglieder",
      "surveys.table_head.status": "Status",
      "surveys.table_head.total_invites_received": "Gesamtzahl der Einladungen",
      "surveys.manager_self_survey_link":
        "Link zur Selbstbewertung der Führungskraft",
      "surveys.view_as_manager": "Als Führungskraft ansehen",
      "surveys.results_preview": "Ergebnis-Vorschau",
      "surveyResults.view_as_banner":
        "Ansicht der Ergebnisse als {{name}} (Admin-Vorschau)",
      "surveyResults.view_as_exit": "Vorschau beenden",
      "surveys.name_filter_placeholder": "Suche",
      "create_survey.create_draft": "Entwurf erstellen",
      "create_survey.save_draft": "Entwurf speichern",
      "create_survey.clear_selection": "Auswahl löschen",
      "create_survey.select_all_managers_and_employees":
        "Alle Manager und Mitarbeiter auswählen",
      "create_survey.select_all_managers": "Alle Manager auswählen",
      "create_survey.link_existing_employee":
        "Bestehenden Mitarbeiter verknüpfen",
      "create_survey.cancel_btn": "Abbrechen",
      "create_survey.launch_btn": "Starten",
      "create_survey.template_label": "Vorlage",
      "create_survey.start_date_label": "Startdatum",
      "create_survey.duration_label": "Dauer",
      "create_survey.managers_invite_employees_label":
        "Die Führungskraft läd ihre Mitarbeiter ein",
      "create_survey.survey_title_lable": "Umfragetitel",
      "create_survey.invite_based_survey_label":
        "Mitarbeiter per E-Mail einladen",
      "create_survey.self_survey_requested_label":
        "Selbsteinschätzung angefordert",
      "create_survey.add_manager_btn": "Führungskraft hinzufügen",
      "create_survey.select_manager_title": "Führungskraft auswählen",
      "create_survey.add_employee_btn": "Mitarbeiter hinzufügen",
      "create_survey.select_employee_title": "Mitarbeiter auswählen",
      "create_survey.launch_btn_loading": "Laden...",
      "tags.search_input": "Gruppen suchen",
      "tags.add_new_btn": "Hinzufügen",
      "modal.new_group.title": "Neue Gruppe",
      "modal.new_group.name_label": "Name",
      "modal.new_group.manager_label": "Führungskraft",
      "modal.new_group.submit_btn": "Hinzufügen",
      "employees.search_input": "Mitarbeiter suchen",
      "employees.add_new_btn": "Hinzufügen",
      "modal.new_employee.title": "Neuer Mitarbeiter",
      "modal.new_employee.first_name_label": "Vorname",
      "modal.new_employee.last_name_label": "Nachname",
      "modal.new_employee.email_label": "E-Mail",
      "modal.new_employee.manager_label": "Führungskraft",
      "modal.new_employee.submit_btn": "Hinzufügen",
      "uploads.select_label": "Führungskraft oder Mitarbeiter auswählen",
      "uploads.select_placeholder": "Importtyp auswählen",
      "uploads.manager_option": "Führungskraft",
      "uploads.employee_option": "Mitarbeiter",
      "uploads.step_1.title": "Führungskraft oder Mitarbeiter auswählen",
      "uploads.step_1.text": "",
      "uploads.step_1.title_manager": "Führungskraft",
      "uploads.step_1.text_manager": "",
      "uploads.step_1.title_employee": "Mitarbeiter",
      "uploads.step_1.text_employee": "",
      "uploads.step_1.manager_btn": "Auswählen",
      "uploads.step_1.employee_btn": "Auswählen",
      "upload_form.import_successful": "Import erfolgreich",
      "upload_form.import_update_successful": "Aktualisierung erfolgreich",
      "upload_form.managers_title": "Führungskraft hochladen",
      "upload_form.employees_title": "Mitarbeiter hochladen",
      "upload_form.sample_file_label": "Beispieldatei",
      "upload_form.sample_file_btn": "Beispieldatei herunterladen",
      "upload_form.upload_file_label": "Datei hochladen",
      "upload_form.table.field_name": "Feldname",
      "upload_form.table.available_fields": "Verfügbare Felder",
      "upload_form.table.edit": "Bearbeiten",
      "upload_form.table.select_placeholder": "Eine Option wählen",
      "upload_form.table.remove_btn": "Entfernen",
      "upload_form.table.import_btn": "Importieren",
      "upload_form.available_fields_label": "Verfügbare Felder",
      "new_survey.back_btn": "Zurück",
      "new_survey.next_btn": "Weiter",
      "new_survey.done_btn": "Fertig",
      "new_survey.step_1.title": "Umfrage starten",
      "new_survey.step_1.text":
        "Möchten Sie eine neue Umfrage von Grund auf erstellen, für neue Führungskräfte und Mitarbeiter oder für bereits hochgeladene Führungskräfte und Mitarbeiter?",
      "new_survey.step_1.title_yes":
        "Ich möchte neue Führungskräfte und Mitarbeiter hochladen",
      "new_survey.step_1.text_yes":
        "Im nächsten Schritt können Sie eine Excel-Vorlage herunterladen, um Führungskräfte und Mitarbeiter einzugeben",
      "new_survey.step_1.title_no":
        "Ich möchte Führungskräfte hochladen oder sie manuell hinzufügen",
      "new_survey.step_1.text_no":
        "Sie haben die Möglichkeit, diese Aufgabe Ihren Führungskräften zu übertragen oder Sie können sie manuell erledigen",
      "new_survey.step_1.title_custom":
        "Ich möchte eine Umfrage für bestehende Führungskräfte starten",
      "new_survey.step_1.text_custom": "",
      "new_survey.step_1.cta_custom": "Neue Umfrage erstellen",
      "new_survey.step_2.title": "Führungskräfte den Umfrageantworten zuordnen",
      "new_survey.step_2.manager_handles_invite_text":
        "Möchten Sie Ihre Führungskräfte bitten, ihre Mitarbeiter hinzuzufügen? Sie können überprüfen, wen sie eingeladen haben",
      "new_survey.step_2.managers_list_text":
        "Haben Sie eine Liste von Führungskräften, die Sie hochladen oder vorbereiten können, oder werden Sie sie manuell hinzufügen?",
      "new_survey.step_5.title": "Bereit zum Start",
      "new_survey.step_5.text_1":
        "Sie sind jetzt bereit, die Umfrage zu starten",
      "new_survey.step_5.text_2": "Im nächsten Schritt",
      "new_survey.step_5.text_2.li_1":
        "Duplikate werden ignoriert, Personen werden anhand ihrer E-Mail erkannt",
      "new_survey.step_5.text_2.li_2":
        "Sie können den Import im nächsten Schritt vorab anzeigen",
      "new_survey.step_5.text_3": "Während die Umfrage aktiv ist",
      "new_survey.step_5.text_3.li_1":
        "Sie haben die Möglichkeit, die eingeladenen Manager während der gesamten Umfragezeit zu überprüfen und zu bearbeiten",
      "analyze.company.all_surveys_placeholder": "Alle Umfragen",
      "analyze.company.all_groups_placeholder": "Alle Gruppen",
      "analyze.company.date_placeholder": "Gesamte Zeit",
      "analyze.company.name_filter_placeholder": "Nach Namen filtern",
      "analyze.company.export_btn": "Exportieren",
      "analyze.company.primary_box":
        "Wie viele Führungskräfte haben ihre Gesamtpunktzahl erhöht?",
      "analyze.company.data_points_title": "Wichtige Datenpunkte",
      "analyze.company.feedback_title": "Offenes Feedback",
      "analyze.company.feedback_box_title": "Feedback",
      "analyze.company.graph_title": "Unternehmensergebnisse",
      "analyze.company.graph_text":
        "Durch Klicken auf die einzelnen Kompetenzen links werden Ihnen die Beschreibungen und die dazugehörigen Fragen angezeigt, die zur Bewertung der Führungskompetenz verwendet wurden. Durch Klicken auf die Punkte in der Graphik können Sie sich die erreichten Werte anzeigen lassen.",
      "analyze.company.insights_title": "Beschreibung",
      "analyze.company.questions_title": "Fragen",
      "analyze.company.cat_description_title": "Beschreibung",
      "analyze.managers.all_surveys_placeholder": "Alle Umfragen",
      "analyze.managers.all_groups_placeholder": "Alle Gruppen",
      "analyze.managers.date_placeholder": "Gesamte Zeit",
      "analyze.managers.name_filter_placeholder": "Nach Namen filtern",
      "analyze.managers.export_btn": "Exportieren",
      "analyze.managers.generate_summaries_btn": "Zusammenfassungen generieren",
      "analyze.managers.regenerate_confirmation":
        "Sind Sie sicher, dass Sie Zusammenfassungen für alle Manager neu generieren möchten? Dies kann einige Zeit in Anspruch nehmen.",
      "analyze.managers.generating_summaries": "Wird generiert...",
      "analyze.managers.primary_box":
        "Welches Element der Führung hat sich am meisten geändert?",
      "analyze.managers.insights_title": "Beschreibung",
      "analyze.managers.questions_title": "Fragen",
      "analyze.managers.cat_description_title": "Beschreibung",
      "analyze.managers.feedback_box_title": "Feedback",
      "analyze.managers.summary": "Zusammenfassung",
      "analyze.managers.list": "Liste",
      "analyze.managers.download_pdf": "Als PDF herunterladen",
      "analyze.managers.generating_pdf": "PDF wird erstellt...",
      "analyze.managers.popup_blocked":
        "Popup wurde blockiert. Bitte erlauben Sie Popups für diese Website und versuchen Sie es erneut.",
      "analyze.managers.no_results": "Keine Ergebnisse",
      "analyze.managers.summary_generated_success":
        "Manager-Zusammenfassung erfolgreich generiert",
      "analyze.managers.no_closed_surveys":
        "Für diesen Manager wurden noch keine geschlossenen Umfragen gefunden. Umfragen müssen geschlossen werden, bevor Zusammenfassungen generiert werden können.",
      "analyze.managers.no_open_text_feedback":
        "Die geschlossenen Umfragen dieses Managers enthalten kein schriftliches Feedback, das zusammengefasst werden kann.",
      "analyze.managers.no_closed_surveys_company":
        "{{count}} Umfrage(n) für Manager in diesem Unternehmen gefunden, aber noch keine wurden geschlossen. Umfragen müssen geschlossen werden, bevor Zusammenfassungen generiert werden können.",
      "analyze.managers.no_closed_surveys_feedback":
        "Keine geschlossenen Umfragen mit Nutzer-Feedback für Manager in diesem Unternehmen gefunden",
      "analyze.managers.summaries_generated_success":
        "Manager-Zusammenfassungen erfolgreich für {{count}} Manager generiert",
      "analyze.managers.summaries_generation_started":
        "Zusammenfassungen für {{count}} Manager werden im Hintergrund generiert. Sie können weiterarbeiten; wir benachrichtigen Sie, sobald sie fertig sind.",
      "analyze.managers.summaries_already_generating":
        "Für dieses Unternehmen werden bereits Zusammenfassungen generiert. Wir benachrichtigen Sie, sobald sie fertig sind.",
      "analyze.managers.summaries_progress":
        "Zusammenfassungen werden generiert: {{processed}} von {{total}} Managern fertig",
      "analyze.managers.summaries_ready":
        "Zusammenfassungen für {{count}} von {{total}} Managern fertig",
      "analyze.managers.summaries_interrupted":
        "Die Generierung der Zusammenfassungen wurde unterbrochen. Bitte klicken Sie erneut auf „Zusammenfassungen generieren“.",
      "analyze.managers.summary_header": "Zusammenfassung der Rückmeldungen",
      "analyze.managers.recommendation_header": "Top-Empfehlung:",
      "analyze.managers.count_statement":
        "Insgesamt basiert die Auswertung auf {{count}} nutzbaren Antworten.",
      "anaylze.managers.self_assessed": "Selbsteinschätzung",
      "analyze.survey.back_btn": "Zurück",
      "analyze.groups.rank": "Rang",
      "analyze.groups.highest_ratings": "Höchste Bewertungen",
      "analyze.groups.highest_ratings_subtitle": "95% Perzentil",
      "analyze.groups.distribution": "Verteilung",
      "analyze.groups.list": "Liste",
      "analyze.groups.managers": "Führungskraft",
      "analyze.groups.inspect": "Inspektion",
      "analyze.groups.rest": "Rest",
      "analyze.groups.lowest_ratings": "Niedrigste Bewertungen",
      "analyze.groups.lowest_ratings_subtitle": "5% Perzentil",
      "analyze.widgets.leadership_increase_most_by_percent": "hat zugenommen",
      "analyze.widgets.leadership_decrease_most_by_percent": "hat abgenommen",
      "analyze.widgets.leadership_change_most_least_score.most":
        "hat die meisten Änderungen",
      "analyze.widgets.leadership_change_most_least_score.least":
        "hat die geringsten Änderungen",
      "analyze.widgets.leadership_highest_score": "hat die höchste Punktzahl",
      "analyze.widgets.leadership_lowest_score": "hat die niedrigste Punktzahl",
      "analyze.widgets.question_lowest_score_all_manager":
        "Frage mit der niedrigsten Punktzahl unter allen Managern",
      "settings.title": "Firmeneinstellungen",
      "settings.data.title": "Firmendaten",
      "settings.data.name": "Name:",
      "settings.data.address": "Adresse:",
      "settings.data.address_number": "Adressnummer:",
      "settings.data.btn": "Firmendaten speichern",
      "settings.data.save_language": "Sprache speichern",
      "settings.save_other_settings": "Andere Einstellungen speichern",
      "settings.self_survey_required": "Selbstbewertung erforderlich",
      "settings.aiPrompt.title": "KI-Zusammenfassungsvorlage",
      "settings.aiPrompt.description":
        "Passen Sie die KI-Vorlage für die Generierung von Manager-Zusammenfassungen an. Diese Vorlage wird verwendet, wenn KI-Zusammenfassungen für Umfrageergebnisse generiert werden.",
      "settings.aiPrompt.loadGlobal": "Globale Vorlage laden",
      "settings.aiPrompt.resetToGlobal": "Globale Vorlage verwenden",
      "settings.aiPrompt.companySpecific":
        "Sie bearbeiten eine unternehmensspezifische Vorlage",
      "settings.aiPrompt.usingGlobal": "Sie verwenden die globale Vorlage",
      "settings.aiPrompt.saveAsCompany": "Als Unternehmensvorlage speichern",
      "settings.aiPrompt.updateCompany": "Unternehmensvorlage aktualisieren",
      "settings.aiPrompt.availableVariables": "Verfügbare Variablen:",
      "settings.aiPrompt.variables.quantitativeData":
        "{{quantitativeData}} - Quantitative Umfragewerte und Metriken",
      "settings.aiPrompt.variables.qualitativeData":
        "{{qualitativeData}} - Qualitative Rückmeldungen und Kommentare",
      "settings.aiPrompt.role": "Rolle",
      "settings.aiPrompt.rolePlaceholder":
        "Geben Sie die Rollen-/Charakterbeschreibung ein (der <Rolle>-Abschnitt)...",
      "settings.aiPrompt.template": "Vorlage",
      "settings.aiPrompt.templatePlaceholder":
        "Geben Sie die Hauptvorlage ein (alles andere)...",
      "settings.aiPrompt.save": "Vorlage speichern",
      "settings.aiPrompt.saving": "Speichern...",
      "settings.aiPrompt.saved": "Vorlage erfolgreich gespeichert!",
      "settings.aiPrompt.error":
        "Fehler beim Speichern der Vorlage. Bitte versuchen Sie es erneut.",
      "settings.language_options": "Sprachoptionen",
      "settings.academy_contents": "Akademie-Inhalte",
      "settings.other_settings": "Andere Einstellungen",
      "settings.default_language": "Standard-Sprache",
      "settings.available_languages": "Verfügbare Sprachen",
      "settings.custom_fields.title": "Benutzerdefiniertes Feld",
      "settings.new_field.title": "Neues benutzerdefiniertes Feld hinzufügen",
      "settings.choose_widget": "Widget auswählen",
      "settings.save_widgets": "Widget-Auswahl speichern",
      "settings.new_field.name": "Feldname",
      "settings.new_field.btn": "Benutzerdefiniertes Feld hinzufügen",
      "settings.selected": "Ausgewählt",
      "settings.not_selected": "Nicht ausgewählt",
      "settings.data.saved": "Firmendaten gespeichert",
      "settings.enabled": "Aktiviert",
      "settings.disabled": "Deaktiviert",
      "modal.btn.save": "Speichern",
    },
  },
  zh: {
    translation: {
      "splash.tag_line": "以數據衡量領導力",
      // general info
      "general.no_results_found": "未找到結果",
      "general.copied_to_clipboard": "已複製到剪貼板",
      "general.participants_added": "參與者已成功添加",
      "general.survey_saved_as_draft": "調查已保存為草稿",
      "general.survey_launched": "調查已成功啟動",
      "general.manager_added_successfully": "管理員已成功添加",
      "general.employee_added_successfully": "員工已成功添加",
      "general.manager_not_added": "管理員未添加",
      "general.employee_not_added": "員工未添加",
      "general.reminder_sent": "提醒已發送",

      // error messages
      "error.errors_to_correct": "需要修正的錯誤：",
      "error.field_length_2_chars": "字段必須至少2個字符",
      "error.invalid_email": "無效的電子郵件地址",

      //field options / names
      "field.options_choose": "選擇以下其中一項",
      "field.options_full_list": "我有完整的員工和管理員名單",
      "field.options.partial_list": "我沒有名單或只有部分管理員名單",
      "field.have_list_managers": "您有管理員名單嗎？",
      "field.yes": "是",
      "field.no": "否",
      "field.will_managers_add_employees": "管理員會添加員工嗎？",
      "field.first_name": "名字",
      "field.last_name": "姓氏",
      "field.email": "電子郵件",
      "field.manager_emails": "管理員電子郵件",
      "field.manager": "管理員",
      "field.group": "組別",
      "field.language": "語言",

      // Survey header menu
      "menu.logout": "登出",
      "menu.new_survey": "新調查",
      "menu.analyze.company": "公司",
      "menu.analyze.groups": "組別",
      "menu.analyze.managers": "管理員",
      "menu.manage.managers": "管理員",
      "menu.manage.surveys": "調查",
      "menu.manage.groups": "組別",
      "menu.manage.employees": "員工",
      "menu.manage.uploads": "上傳",
      "menu.manage.settings": "設置",

      // Footer texts
      "footer.copyright": "2026 VeeMind",
      "footer.trust": "",
      "footer.support": "支援",
      "footer.impressum": "法律聲明",

      //Survey Steps
      "surveySteps.completed_message": "您已完成此調查",

      // Survey step 1
      "step1.owner": "您正在为",
      "step1.owner_suffix": "提供反馈",
      "step1.feature1": "目的",
      "step1.feature2": "反馈",
      "step1.feature3": "数据",
      "step1.feature4": "目标",
      "step1.explainer1":
        "您受邀参与本次调查，旨在分享您对领导行为的反馈意见。",
      "step1.explainer2": "请在作答和评论中保持坦诚并给予支持。",
      "step1.explainer3": "您的回答将被保密且匿名处理。",
      "step1.explainer4": "您的反馈将帮助管理者反思其领导方式并加强团队协作。",
      "step1.cta": "开始调查",
      "step1.timeestimate": "完成本调查大约需要10-15分钟。",
      "step1.minutes": "",

      // Survey step 2
      "step2.title": "领导力调查",
      "step2.description": "您正在为以下人员提供反馈",
      "step2.cta": "下一步",

      //Survey Step 2 Values
      completely_agree: "完全同意",
      mostly_agree: "基本同意",
      somewhat_agree: "有點同意",
      somewhat_disagree: "有點不同意",
      mostly_disagree: "基本不同意",
      completely_disagree: "完全不同意",
      not_applicable: "唔能夠判斷",

      // Survey step 3
      "step3.title": "您即将完成！",
      "step3.description":
        "您即将完成调查。在最后一部分，您可以向您的管理者提供额外的反馈。",
      "step3.description-self": "您几乎完成了自我评估",
      "step3.cta": "提交调查",

      // Survey step 4
      "step4.title": "謝謝，我們感謝您的意見！",
      "step4.text":
        "如果您想與VeeMind分享您的經驗，我們很高興在support@veemind.com收到您的消息。",
      "step4.teasertitle": "您是一位好領導嗎？",
      "step4.teasertext":
        "您想從員工那裡獲得良好和誠實的反饋嗎？免費使用VeeMind開始您自己的調查",
      "step4.cta": "開始調查",

      // Content Card (Academy)
      "academy.category.title": "元素",
      "academy.subcategory.title": "技能",
      "academy.reading_time": "閱讀時間",
      "academy.minutes": "分鐘",
      "academy.intro.title": "介紹",
      "academy.content.title": "我能做什麼？",
      "academy.read-more": "閱讀更多",

      //Home
      "home.card_small_title": "調查",
      "home.cta": "選擇調查",

      //Login
      "login.title": "了解您自己的領導風格",
      "login.text": "創建一個調查來詢問您的團隊或您自己，您是什麼樣的領導者",
      "login.cta": "登入",
      "login.terms_of_use.text": "通過創建帳戶，我同意",
      "login.terms_of_use.cta": "服務條款",

      //Survey Conf
      "surveyConf.category.title": "元素",
      "surveyConf.subcategory.title": "技能",
      "surveyConf.subcategory.question_title": "問題",
      "surveyConf.page_title": "開始您的調查",
      "surveyConf.page_text": "這是將分發的問題預覽",
      "surveyConf.box.title": "指南",
      "surveyConf.box.text_1":
        "在下一步中，您將被要求向您的團隊成員分發訪問信息，您可以通過提供他們的電子郵件或給他們直接鏈接來完成此操作\n\n下面的部分說明了我們將用於評估您的領導風格的系統以及我們向您的團隊提出的問題",
      "surveyConf.box.text_2":
        "要查看我們將發送給您的團隊成員的問題，請單擊下面的每個元素進行探索。我們還將要求他們回答三個開放式問題，他們可以在其中分享他們的建議和反饋。",
      "surveyConf.stats.time": "此調查大約需要：",
      "surveyConf.minutes": "分鐘",
      "surveyConf.stats.categories": "選定的元素：",
      "surveyConf.stats.questions": "總問題數：",
      "surveyConf.stats.cta": "創建調查",

      //SurveyResults
      "surveyResults.info.click_to_complete_self_survey":
        "單擊此處完成自我調查（在新窗口中打開）。",
      "surveyResults.info.after_survey_refresh":
        "完成調查後，請刷新頁面以查看結果。",
      "surveyResults.info.no_results_for_manager": "此管理員沒有調查結果",
      "surveyResults.info.self_assessment_required":
        "在查看結果之前，您需要完成以下自我調查",
      "surveyResults.summary_results_scorecard": "結果記分卡",
      "surveyResults.summary.leadership_elements": "評估的領導力元素",
      "surveyResults.summary.participants": "參與者人數",
      "surveyResults.summary.skills": "評估的領導技能",
      "surveyResults.summary.answers_given": "給出的答案",
      "surveyResults.summary.total_exercises": "完整版本中可用的總練習",
      "surveyResults.summary.opinions_given": "參與者寫的意見",
      "surveyResults.summary.time_average": "平均花費時間",
      "surveyResults.summary.completion_rate": "完成率",
      "surveyResults.summary.title": "摘要",
      "surveyResults.summary.box_text_1": "VeeMind",
      "surveyResults.summary.box_text_2": "企業版",
      "surveyResults.summary.box_cta": "通過電子郵件詢問我們",
      "surveyResults.summary.text_bold": "此調查是VeeMind企業版的預覽",
      "surveyResults.summary.text_1": "感謝您花時間使用它",
      "surveyResults.summary.text_2":
        "如果您想在您的公司使用我們的解決方案，我們的平台可以實現更多數據驅動的決策，例如：",
      "surveyResults.summary.text_list_1": "整個公司領導質量概覽",
      "surveyResults.summary.text_list_2": "歷史統計",
      "surveyResults.summary.text_list_3": "輕鬆的調查管理",

      //Page Content
      "surveyResults.page_title": "結果概覽",
      "surveyResults.page_text": "此頁面顯示並解釋您的結果",
      "surveyResults.no_results.title": "無結果",
      "surveyResults.no_results.text": "調查完成後，結果將可用",
      "surveyResults.strength.title": "優勢",
      "surveyResults.weakness.title": "弱點",
      "surveyResults.feedback.title": "開放式反饋",
      "surveyResults.feedback.no_results": "無可用結果",
      "surveyResults.feedback.show_all": "顯示全部",
      "surveyResults.category.title": "元素",
      "surveyResults.subcategory.title": "技能",
      "surveyResults.category.subcategories_included": "包含的技能",
      "surveyResults.subcategory.tooltip.self-assess": "自我評估",
      "surveyResults.subcategory.academy-cta": "改進",
      "surveyResults.subcategory.question_title": "問題",
      "surveyResults.select_survey": "選擇一個或多個調查",
      "surveyResults.all_surveys": "所有調查",

      //Tabs
      //Total Results
      "tab.results.survey_title.label": "調查標題",
      "tab.results.started_on.label": "開始於",
      "tab.results.end_date.label": "結束日期",
      "tab.results.end_date.text": "或當所有回复提交時",
      "tab.results.status.label": "狀態",
      "tab.results.survey_closed": "此調查現已關閉",

      //Tab Email
      "tab.email.title": "使用電子郵件",
      "tab.email.invite-emails.label": "通過電子郵件邀請",
      "tab.email.invite-emails.placeholder": "收件人電子郵件（逗號分隔）",
      "tab.email.invite-emails.not_valid_message": "以下電子郵件無效",
      "tab.email.invite-emails.already_sent_message": "以下已收到邀請",
      "tab.email.invite-emails.send_to_your_email_message":
        "您不能向自己發送邀請",
      "tab.email.tracking.label": "回复跟踪",
      "tab.email.tracking.list_item_1": "自動提醒",
      "tab.email.tracking.list_item_2": "進度跟踪",
      "tab.email.tracking.list_item_3": "調查在最後一位受訪者時關閉",
      "tab.email.end_date.label": "結束日期",
      "tab.email.end_date.text": "或當所有回复提交時",
      "tab.email.self-assess.cta": "自我評估",
      "tab.email.invite.cta": "邀請",

      //Tab URL
      "tab.url.title": "使用鏈接",
      "tab.stats.title": "狀態",
      "tab.url.invite-url.label": "分享URL",
      "tab.url.invite-url.text":
        "使用上面的鏈接與您的團隊分享，並確保單擊按鈕開始調查。",
      "tab.url.invite-url.cta.share": "分享",
      "tab.url.invite-url.cta.copied": "已複製！",
      "tab.url.tracking.label": "回复跟踪",
      "tab.url.tracking.text":
        "通過電子郵件邀請可以幫助您獲得最佳結果。電子郵件邀請啟用：",
      "tab.url.tracking.list_item_1": "自動提醒",
      "tab.url.tracking.list_item_2": "進度跟踪",
      "tab.url.tracking.list_item_3": "調查在最後一位受訪者時關閉",
      "tab.url.end_date.label": "結束日期",
      "tab.url.end_date.text": "將在午夜關閉",
      "tab.url.self-assess.cta": "自我評估",

      //Register Modal
      "modal.register_user.title": "告訴我們更多關於您自己的信息",
      "modal.register_user.text":
        "我們仍在學習如何使這個平台在各個行業和環境中具有相關性 - 您提供的數據將非常有價值。抱歉帶來不便，謝謝！",
      "modal.register_user.q1": "您的姓名和姓氏是什麼？",
      "modal.register_user.first_name": "名字",
      "modal.register_user.last_name": "姓氏",
      "modal.register_user.q2": "什麼最能描述您的角色？",
      "modal.register_user.choose": "選擇一個",
      "modal.register_user.q3": "您的行業是什麼？",
      "modal.register_user.q4": "指定您的行業",
      "modal.register_user.q5": "您在哪裡？",
      "modal.register_user.q6": "您管理的團隊規模是多少？",
      "modal.register_user.q7": "您的公司規模是多少？",
      "modal.register_user.q8": "您的公司是否有領導力和/或公司文化指南？",
      "modal.register_user.cta": "保存",

      //Managers
      "managers.search_input": "搜索管理員",
      "managers.add_new_btn": "添加",
      "managers.no_managers_found": "未找到管理員。",
      "managers.copy_invite": "複製調查鏈接",

      //Table
      "table.edit_btn": "編輯",
      "table.save_btn": "保存",
      "table.archive_btn": "歸檔",
      "table.delete_btn": "刪除",

      //Modal New Manager
      "modal.new_manager.title": "新管理員",
      "modal.new_manager.first_name": "名字",
      "modal.new_manager.last_name": "姓氏",
      "modal.new_manager.email": "電子郵件",
      "modal.new_manager.submit_btn": "添加",

      //Modal Link Employee
      "modal.link_employee.title": "選擇要鏈接的員工",
      "modal.link_employee.search_input": "按名稱搜索",
      "modal.link_employee.selection": "員工選擇",
      "modal.link_employee.selected_employees": "選定的員工",
      "modal.link_employee.link_button": "鏈接員工",
      "modal.link_employee.cancel_button": "取消",

      //Surveys
      "surveys.start": "開始",
      "surveys.end": "結束",
      "surveys.invite_link": "邀請鏈接",
      "surveys.send_reminder": "發送提醒",
      "surveys.not_active": "調查未激活",
      "surveys.completed": "調查已完成",
      "surveys.copy": "複製鏈接",
      "surveys.all_surveys_placeholder": "所有調查",
      "surveys.draft_surveys_placeholder": "草稿調查",
      "surveys.active_surveys_placeholder": "活動調查",
      "surveys.invited_managers": "受邀管理員",
      "surveys.invited_employees": "受邀員工",
      "surveys.title": "調查",
      "surveys.add_new_btn": "添加",
      "surveys.starting_date": "調查開始日期",
      "surveys.closing_date": "調查結束日期",
      "surveys.completion_rate": "完成率",
      "surveys.closed": "調查已關閉",
      "surveys.closed_yes": "是",
      "surveys.closed_no": "否",
      "surveys.invite_based": "基於邀請的調查",
      "surveys.link": "調查鏈接",
      "surveys.link_to_survey": "公共調查鏈接",
      "surveys.invite_based_no": "否",
      "surveys.invite_based_yes": "是",
      "surveys.no_results_found": "未找到調查結果。",
      "surveys.survey_not_started": "調查尚未開始",
      "surveys.status.not_started": "未開始",
      "surveys.status.active": "活動",
      "surveys.status.closed": "已關閉",
      "surveys.status.completed": "已完成",
      "surveys.status.in_progress": "進行中",
      "surveys.button.see_results": "查看結果",
      "surveys.button.add_participants": "添加參與者",
      "surveys.button.duplicate": "複製",
      "surveys.tab.managers": "管理員",
      "surveys.tab.employees": "員工",
      "surveys.table_head.name_email": "姓名 / 電子郵件",
      "surveys.table_head.email": "電子郵件",
      "surveys.table_head.manager": "管理員",
      "surveys.table_head.total_responses": "總回复數",
      "surveys.table_head.team_members_invited": "受邀團隊成員",
      "surveys.table_head.status": "狀態",
      "surveys.table_head.total_invites_received": "收到的總邀請數",
      "surveys.manager_self_survey_link": "管理員自我調查鏈接",
      "surveys.view_as_manager": "以管理員身份查看",
      "surveys.results_preview": "結果預覽",
      "surveyResults.view_as_banner":
        "以 {{name}} 的身份查看結果（管理員預覽）",
      "surveyResults.view_as_exit": "退出預覽",
      "surveys.name_filter_placeholder": "搜索",

      //Create Survey
      "create_survey.create_draft": "創建草稿",
      "create_survey.save_draft": "保存草稿",
      "create_survey.clear_selection": "清除選擇",
      "create_survey.select_all_managers_and_employees": "選擇所有管理員和員工",
      "create_survey.select_all_managers": "選擇所有管理員",
      "create_survey.link_existing_employee": "鏈接現有員工",
      "create_survey.cancel_btn": "取消",
      "create_survey.launch_btn": "啟動",
      "create_survey.template_label": "模板",
      "create_survey.start_date_label": "開始日期",
      "create_survey.duration_label": "持續時間",
      "create_survey.managers_invite_employees_label": "管理員邀請他們的員工",
      "create_survey.survey_title_lable": "調查標題",
      "create_survey.invite_based_survey_label": "通過電子郵件發送員工邀請",
      "create_survey.self_survey_requested_label": "請求自我評估",
      "create_survey.add_manager_btn": "添加管理員",
      "create_survey.select_manager_title": "選擇管理員",
      "create_survey.add_employee_btn": "添加員工",
      "create_survey.select_employee_title": "選擇員工",
      "create_survey.launch_btn_loading": "加載中...",

      //Groups
      "tags.search_input": "搜索組別",
      "tags.add_new_btn": "添加",

      //Modal New Group
      "modal.new_group.title": "新組別",
      "modal.new_group.name_label": "名稱",
      "modal.new_group.manager_label": "管理員",
      "modal.new_group.submit_btn": "添加",

      //Employees
      "employees.search_input": "搜索員工",
      "employees.add_new_btn": "添加",

      //Modal New Employee
      "modal.new_employee.title": "新員工",
      "modal.new_employee.first_name_label": "名字",
      "modal.new_employee.last_name_label": "姓氏",
      "modal.new_employee.email_label": "電子郵件",
      "modal.new_employee.manager_label": "管理員",
      "modal.new_employee.submit_btn": "添加",

      //Uploads
      "uploads.select_label": "選擇管理員或員工",
      "uploads.select_placeholder": "選擇導入類型",
      "uploads.manager_option": "管理員",
      "uploads.employee_option": "員工",
      "uploads.step_1.title": "選擇管理員或員工",
      "uploads.step_1.text": "",
      "uploads.step_1.title_manager": "管理員",
      "uploads.step_1.text_manager": "",
      "uploads.step_1.title_employee": "員工",
      "uploads.step_1.text_employee": "",
      "uploads.step_1.manager_btn": "選擇",
      "uploads.step_1.employee_btn": "選擇",

      //Upload Form
      "upload_form.import_successful": "導入成功",
      "upload_form.import_update_successful": "更新成功",
      "upload_form.managers_title": "上傳管理員",
      "upload_form.employees_title": "上傳員工",
      "upload_form.sample_file_label": "示例文件",
      "upload_form.sample_file_btn": "下載示例文件",
      "upload_form.upload_file_label": "上傳文件",
      "upload_form.table.field_name": "字段名稱",
      "upload_form.table.available_fields": "可用字段",
      "upload_form.table.edit": "編輯",
      "upload_form.table.select_placeholder": "選擇以下其中一項",
      "upload_form.table.remove_btn": "刪除",
      "upload_form.table.import_btn": "導入",
      "upload_form.available_fields_label": "可用字段",

      //New Survey
      "new_survey.back_btn": "返回",
      "new_survey.next_btn": "下一步",
      "new_survey.done_btn": "完成",
      "new_survey.step_1.title": "啟動調查",
      "new_survey.step_1.text":
        "您想從頭開始創建新調查，為新的管理員和員工，還是為以前上傳的管理員和員工？",
      "new_survey.step_1.title_yes": "我想上傳新的管理員和員工",
      "new_survey.step_1.text_yes":
        "在下一步中，您將能夠下載Excel模板以輸入管理員和員工",
      "new_survey.step_1.title_no": "我想上傳管理員或手動添加",
      "new_survey.step_1.text_no":
        "您可以選擇將此任務委派給您的管理員，或者您可以手動完成",
      "new_survey.step_1.title_custom": "我想為現有管理員啟動調查",
      "new_survey.step_1.text_custom": "",
      "new_survey.step_1.cta_custom": "創建新調查",
      "new_survey.step_2.title": "將管理員映射到報告",
      "new_survey.step_2.manager_handles_invite_text":
        "您想要求您的管理員添加他們的員工嗎？您將能夠檢查他們邀請了誰",
      "new_survey.step_2.managers_list_text":
        "您有可以上傳或準備的管理員名單，還是會手動添加？",
      "new_survey.step_5.title": "準備啟動",
      "new_survey.step_5.text_1": "您現在準備啟動調查",
      "new_survey.step_5.text_2": "在下一步中",
      "new_survey.step_5.text_2.li_1": "重複項被忽略，人員通過其電子郵件識別",
      "new_survey.step_5.text_2.li_2": "您將能夠在下一步中預覽導入",
      "new_survey.step_5.text_3": "當調查處於活動狀態時",
      "new_survey.step_5.text_3.li_1":
        "您將能夠在整個調查期間檢查和編輯受邀管理員",

      //Analyze Company
      "analyze.company.all_surveys_placeholder": "所有調查",
      "analyze.company.all_groups_placeholder": "所有組別",
      "analyze.company.date_placeholder": "所有時間",
      "analyze.company.name_filter_placeholder": "按名稱過濾",
      "analyze.company.export_btn": "導出",
      "analyze.company.primary_box": "有多少管理員提高了他們的總分？",
      "analyze.company.data_points_title": "關鍵數據點",
      "analyze.company.feedback_title": "定性反饋",
      "analyze.company.feedback_box_title": "反饋",
      "analyze.company.graph_title": "公司矩陣",
      "analyze.company.graph_text":
        "通過單擊左側的每個能力，您將看到用於評估領導能力的描述和相應問題。通過單擊圖表中的點，您可以看到達到的分數。",
      "analyze.company.insights_title": "類別描述",
      "analyze.company.questions_title": "示例問題",
      "analyze.company.cat_description_title": "類別描述",

      //Analyze Managers
      "analyze.managers.all_surveys_placeholder": "所有調查",
      "analyze.managers.all_groups_placeholder": "所有組別",
      "analyze.managers.date_placeholder": "所有時間",
      "analyze.managers.name_filter_placeholder": "按名稱過濾",
      "analyze.managers.export_btn": "導出",
      "analyze.managers.generate_summaries_btn": "生成摘要",
      "analyze.managers.regenerate_confirmation":
        "您確定要為所有經理重新生成摘要嗎？這可能需要一些時間。",
      "analyze.managers.generating_summaries": "生成中...",
      "analyze.managers.primary_box": "領導力的哪個元素變化最大？",
      "analyze.managers.insights_title": "類別描述",
      "analyze.managers.questions_title": "示例問題",
      "analyze.managers.cat_description_title": "類別描述",
      "analyze.managers.feedback_box_title": "反饋",
      "analyze.managers.summary": "摘要",
      "analyze.managers.list": "列表",
      "analyze.managers.download_pdf": "下載PDF",
      "analyze.managers.generating_pdf": "正在生成PDF...",
      "analyze.managers.popup_blocked":
        "彈出視窗已被攔截。請允許此網站的彈出視窗後重試。",
      "analyze.managers.no_results": "無結果",
      "analyze.managers.summary_generated_success": "管理員摘要生成成功",
      "analyze.managers.no_closed_surveys":
        "尚未找到此管理員的已關閉調查。必須先關閉調查才能生成摘要。",
      "analyze.managers.no_open_text_feedback":
        "此管理員的已關閉調查中沒有可供摘要的書面反饋。",
      "analyze.managers.no_closed_surveys_company":
        "找到此公司管理員的 {{count}} 個調查，但尚未關閉任何調查。必須先關閉調查才能生成摘要。",
      "analyze.managers.no_closed_surveys_feedback":
        "未找到此公司管理員的帶有用戶反饋的已關閉調查",
      "analyze.managers.summaries_generated_success":
        "已成功為 {{count}} 個管理員生成摘要",
      "analyze.managers.summaries_generation_started":
        "正在後台為 {{count}} 個管理員生成摘要。您可以繼續工作，完成後會通知您。",
      "analyze.managers.summaries_already_generating":
        "此公司的摘要已在生成中，完成後會通知您。",
      "analyze.managers.summaries_progress":
        "正在生成摘要：已完成 {{processed}} / {{total}} 個管理員",
      "analyze.managers.summaries_ready":
        "已為 {{count}} / {{total}} 個管理員生成摘要",
      "analyze.managers.summaries_interrupted":
        "摘要生成已中斷。請再次點擊「生成摘要」。",
      "analyze.managers.summary_header": "反饋摘要",
      "analyze.managers.recommendation_header": "頂級建議：",
      "analyze.managers.count_statement":
        "總體而言，評估基於 {{count}} 個可用回應。",
      "anaylze.managers.self_assessed": "自我評估",

      //Analyze Survey
      "analyze.survey.back_btn": "返回",

      //Analyze Groups
      "analyze.groups.rank": "排名",
      "analyze.groups.highest_ratings": "最高評分",
      "analyze.groups.highest_ratings_subtitle": "第95百分位數",
      "analyze.groups.distribution": "分佈",
      "analyze.groups.list": "列表",
      "analyze.groups.managers": "管理員",
      "analyze.groups.inspect": "檢查",
      "analyze.groups.rest": "其餘",
      "analyze.groups.lowest_ratings": "最低評分",
      "analyze.groups.lowest_ratings_subtitle": "第5百分位數",
      "analyze.widgets.leadership_increase_most_by_percent": "已增加",
      "analyze.widgets.leadership_decrease_most_by_percent": "已減少",
      "analyze.widgets.leadership_change_most_least_score.most": "變化最大",
      "analyze.widgets.leadership_change_most_least_score.least": "變化最小",
      "analyze.widgets.leadership_highest_score": "得分最高",
      "analyze.widgets.leadership_lowest_score": "得分最低",
      "analyze.widgets.question_lowest_score_all_manager":
        "所有管理員中得分最低的問題",
      //Settings Page
      "settings.title": "公司設置",
      "settings.data.title": "公司數據",
      "settings.data.name": "名稱：",
      "settings.data.address": "地址：",
      "settings.data.address_number": "地址號碼：",
      "settings.data.btn": "保存公司數據",
      "settings.data.save_language": "保存語言",
      "settings.save_other_settings": "保存其他設置",
      "settings.self_survey_required": "需要自我評估",
      "settings.aiPrompt.title": "AI摘要提示模板",
      "settings.aiPrompt.description":
        "自定義用於生成管理員摘要的AI提示模板。此模板將在用於調查結果生成AI摘要時使用。",
      "settings.aiPrompt.role": "角色",
      "settings.aiPrompt.rolePlaceholder":
        "輸入角色/角色描述（<Rolle>部分）...",
      "settings.aiPrompt.template": "模板",
      "settings.aiPrompt.templatePlaceholder":
        "輸入主要提示模板（其他所有內容）...",
      "settings.aiPrompt.save": "保存提示",
      "settings.aiPrompt.saving": "保存中...",
      "settings.aiPrompt.saved": "模板已成功保存！",
      "settings.aiPrompt.error": "保存模板時出錯。請重試。",
      "settings.language_options": "語言選項",
      "settings.academy_contents": "學院內容",
      "settings.other_settings": "其他設置",
      "settings.default_language": "默認語言",
      "settings.available_languages": "可用語言",
      "settings.custom_fields.title": "自定義字段",
      "settings.new_field.title": "添加新自定義字段",
      "settings.choose_widget": "選擇小部件",
      "settings.save_widgets": "保存小部件選擇",
      "settings.new_field.name": "字段名稱",
      "settings.new_field.btn": "添加自定義字段",
      "settings.selected": "已選中",
      "settings.not_selected": "未選中",
      "settings.data.saved": "公司數據已保存",
      "settings.disabled": "已禁用",
      "modal.btn.save": "保存",
    },
  },
  es: {
    translation: {
      "step1.owner": "Está proporcionando comentarios sobre",
      "step1.feature1": "Propósito",
      "step1.feature2": "Comentarios",
      "step1.feature3": "Datos",
      "step1.feature4": "Objetivo",
      "step1.explainer1":
        "Se le ha invitado a participar en esta encuesta para compartir sus comentarios sobre el comportamiento de liderazgo.",
      "step1.explainer2":
        "Sea sincero y alentador en sus respuestas y comentarios.",
      "step1.explainer3": "Sus respuestas serán confidenciales y anónimas.",
      "step1.explainer4":
        "Sus comentarios ayudarán al gerente a reflexionar sobre su enfoque de liderazgo y a fortalecer la colaboración.",
      "step1.cta": "Iniciar encuesta",
      "step1.timeestimate":
        "Completar la encuesta le llevará entre 10 y 15 minutos.",
      "step2.title": "Encuesta sobre liderazgo",
      "step2.description": "Está proporcionando comentarios sobre",
      "step3.title": "¡Ya casi está!",
      "step3.description":
        "Está a punto de terminar la encuesta. En esta última sección, puede proporcionar comentarios adicionales a su gerente.",
      "step3.cta": "Enviar encuesta",
      completely_agree: "Totalmente de acuerdo",
      mostly_agree: "Bastante de acuerdo",
      somewhat_agree: "Algo de acuerdo",
      somewhat_disagree: "Algo en desacuerdo",
      mostly_disagree: "Bastante en desacuerdo",
      completely_disagree: "Totalmente en desacuerdo",
      not_applicable: "No evaluable",
      "step2.cta": "SIGUIENTE",
      "step3.description-self": "Ya casi terminas la autoevaluación",
      "step4.title":
        "Gracias por su participación. Agradecemos mucho sus aportaciones.",
    },
  },
  fr: {
    translation: {
      "step1.owner": "Vous donnez votre avis sur",
      "step1.feature1": "Raison",
      "step1.feature2": "Commentaires",
      "step1.feature3": "Données",
      "step1.feature4": "Objectif",
      "step1.explainer1":
        "Vous avez été invité à participer à cette enquête afin de partager votre avis sur le comportement managérial.",
      "step1.explainer2":
        "Veuillez répondre et commenter de manière honnête et constructive.",
      "step1.explainer3":
        "Vos réponses seront traitées de manière confidentielle et anonyme.",
      "step1.explainer4":
        "Vos commentaires aideront le responsable à réfléchir à son comportement managérial et à renforcer la collaboration.",
      "step1.cta": "Commencer l'enquête",
      "step1.timeestimate":
        "Il vous faudra environ 10 à 15 minutes pour répondre à l'enquête.",
      "step2.title": "Enquête sur le leadership",
      "step2.description": "Vous donnez votre avis sur",
      "step3.title": "Vous y êtes presque !",
      "step3.description":
        "Vous avez presque terminé le sondage. Dans cette dernière section, vous pouvez fournir des commentaires supplémentaires à votre responsable.",
      "step3.cta": "Soumettre le sondage",
      completely_agree: "Tout à fait d'accord",
      mostly_agree: "Plutôt d'accord",
      somewhat_agree: "Légèrement d'accord",
      somewhat_disagree: "Légèrement en désaccord",
      mostly_disagree: "Plutôt en désaccord",
      completely_disagree: "Pas du tout d'accord",
      not_applicable: "Non évaluable",
      "step2.cta": "SUIVANT",
      "step3.description-self": "Vous avez presque terminé l'auto-évaluation",
      "step4.title":
        "Merci pour votre participation. Vos réponses sont très précieuses.",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
